import { createContext, ReactNode, FC } from 'react';

type CheckoutServerVarsContext = {
    isMobile: boolean;
};

export const CheckoutServerVarsContext = createContext<CheckoutServerVarsContext>({
    isMobile: false,
});

type Props = {
    children: ReactNode;
    isMobile: boolean;
};

export const CheckoutServerVarsContextProvider: FC<Props> = ({ children, isMobile }) => (
    <CheckoutServerVarsContext.Provider
        value={{
            isMobile,
        }}
    >
        {children}
    </CheckoutServerVarsContext.Provider>
);
